import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";

// Combobox simple: Input de texto libre + lista desplegable filtrable.
// options: [{ value, label?, hint? }] o strings.
export default function ComboInput({ value, onChange, options = [], placeholder, testid, className = "", emptyText = "Sin opciones precargadas" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const items = options.map((o) => (typeof o === "string" ? { value: o } : o));
  const q = (value || "").toString().toLowerCase();
  const shown = items.filter((o) => !q || o.value.toLowerCase().includes(q) || (o.label || "").toLowerCase().includes(q));

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={ref} className={`relative ${className}`}>
      <Input value={value || ""} placeholder={placeholder} autoComplete="off"
             onChange={(e) => { onChange(e.target.value); setOpen(true); }}
             onFocus={() => setOpen(true)} data-testid={testid} />
      <button type="button" tabIndex={-1} onClick={() => setOpen((o) => !o)} aria-label="Mostrar opciones"
              className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 text-xs" data-testid={testid ? `${testid}-toggle` : undefined}>▾</button>
      {open && (
        <ul className="absolute z-50 mt-1 left-0 right-0 max-h-56 overflow-auto bg-white border border-slate-200 rounded-md shadow-lg text-sm" data-testid={testid ? `${testid}-list` : undefined}>
          {shown.length === 0 && <li className="px-3 py-2 text-xs text-slate-400 italic">{items.length === 0 ? emptyText : "Sin coincidencias — se usará el texto escrito"}</li>}
          {shown.map((o) => (
            <li key={o.value} onMouseDown={(e) => { e.preventDefault(); onChange(o.value, o); setOpen(false); }}
                className={`px-3 py-1.5 cursor-pointer hover:bg-blue-50 flex justify-between gap-2 ${o.value === value ? "bg-blue-50 font-semibold" : ""}`}
                data-testid={testid ? `${testid}-opt-${o.value}` : undefined}>
              <span>{o.label || o.value}</span>
              {o.hint && <span className="text-xs text-slate-500 font-mono">{o.hint}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
